export enum XmShipMethod {    
    ShipToCenter = 1,
    ShipToRemoteDonor = 2,
    ShipToPhlebot = 3
}